export default {"src":"/_next/static/image/public/images/ic_tick.18d7bbc0a41533978f0fcacae2f1a855.svg","height":20,"width":20};